export class Country {
	id!: number;
	name!: string;
	sigla!: string;

	get isItalia(): boolean {
		return this.sigla === 'IT' || this.name === 'Italia';
	}
}
